import { Controller } from "@hotwired/stimulus"
import { debounce } from "lodash"

export default class extends Controller {
  static targets = ["input", "dropdown"]
  static values = { url: String }

  initialize() {
    this.debouncedSearch = debounce(this.performSearch.bind(this), 300)
    this.hideDropdown = this.hideDropdown.bind(this)
  }

  connect() {
    // Close dropdown when clicking outside
    document.addEventListener("click", this.hideDropdown)
  }

  disconnect() {
    document.removeEventListener("click", this.hideDropdown)
  }

  search(event) {
    const query = this.inputTarget.value.trim()
    
    if (query.length === 0) {
      this.hideDropdown()
      return
    }
    
    if (query.length < 2) {
      return
    }

    this.debouncedSearch(query)
  }

  async performSearch(query) {
    try {
      const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      
      if (response.ok) {
        const html = await response.text()
        this.dropdownTarget.innerHTML = html
        this.showDropdown()
      }
    } catch (error) {
      console.error("Search error:", error)
    }
  }

  showDropdown() {
    this.dropdownTarget.classList.remove("hidden")
  }

  hideDropdown(event) {
    // Don't hide if clicking inside the search container
    if (event && this.element.contains(event.target)) {
      return
    }
    
    this.dropdownTarget.classList.add("hidden")
  }

  handleKeydown(event) {
    switch (event.key) {
      case "Escape":
        this.hideDropdown()
        this.inputTarget.blur()
        break
      case "Enter":
        event.preventDefault()
        const query = this.inputTarget.value.trim()
        if (query) {
          window.location.href = `/search?q=${encodeURIComponent(query)}`
        }
        break
      case "ArrowDown":
        event.preventDefault()
        this.navigateResults("down")
        break
      case "ArrowUp":
        event.preventDefault()
        this.navigateResults("up")
        break
    }
  }

  navigateResults(direction) {
    const results = this.dropdownTarget.querySelectorAll("a")
    if (results.length === 0) return

    const currentIndex = Array.from(results).findIndex(link => 
      link.classList.contains("bg-gray-100")
    )

    // Remove current highlight
    results.forEach(link => link.classList.remove("bg-gray-100"))

    let nextIndex
    if (direction === "down") {
      nextIndex = currentIndex < results.length - 1 ? currentIndex + 1 : 0
    } else {
      nextIndex = currentIndex > 0 ? currentIndex - 1 : results.length - 1
    }

    results[nextIndex].classList.add("bg-gray-100")
    results[nextIndex].scrollIntoView({ block: "nearest" })
  }
} 